var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('span',[_vm._v("COPYRIGHT @ "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"https://moozistudio.com/","target":"_blank","rel":"nofollow"}},[_vm._v("MOOZISTUDIO")]),_vm._v(", Tous les droits sont réservés")]),_c('span',{staticClass:"md:flex hidden items-center"})])
}
var staticRenderFns = []

export { render, staticRenderFns }